var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3642 3.13727C12.8404 1.13545 10.5098 0 8 0C5.49018 0 3.15964 1.13545 1.63582 3.13727C-0.545273 6.00564 -0.545273 9.97951 1.63582 12.8479L8 21.1542L14.3642 12.8479C16.5453 9.97951 16.5453 6.00564 14.3642 3.13727ZM8 3.61527C10.3007 3.61527 12.183 5.49764 12.183 7.7983C12.183 10.099 10.3007 11.9813 8 11.9813C5.69933 11.9813 3.81697 10.099 3.81697 7.7983C3.81697 5.49764 5.69933 3.61527 8 3.61527Z",
    fill: "#8A93AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e7e2b80b37a7dfb3f2aa67fc0c2e2031.svg";
export { ForwardRef as ReactComponent };